import { Subsidy } from '../../../services/subidies/subsidy.model';
import { Contact } from '../../../core/services/user/contact.model';
import { FinanceDeminimi } from '../../../models/finance-deminimi.model';
import { TripleAnwer } from '../../../models/triple-answer.enum';
import { RelanceRole } from '../../../models/relance-role.model';
import { FinanceRelance } from '../../../services/finance-relance/finance-relance.model';
import { ProjectLocation } from '../../../services/project-location/project-location.model';

export class IvvSubsidy extends Subsidy {
	applicationContactRelanceRole?: RelanceRole;
	htmlDescriptions?: IvvDescriptions | null;
	financeDeminimis?: FinanceDeminimi[];
	financeRelance: FinanceRelance;
	projectLocations?: ProjectLocation[];
	projectTitle: string;
	receivedDeminimis: TripleAnwer;
	responsibleForOrganizationContact: Contact;

	constructor(obj: any = {}) {
		super(obj);

		this.applicationContactRelanceRole = obj.applicationContactRelanceRole;
		this.htmlDescriptions = obj.htmlDescriptions ? new IvvDescriptions(obj.htmlDescriptions) : null;
		this.financeDeminimis = obj.financeDeminimis ? obj.financeDeminimis.map((fd: any) => new FinanceDeminimi(fd)) : [];
		this.financeRelance = new FinanceRelance(obj.financeRelance);
		this.projectLocations = obj.projectLocations ? obj.projectLocations.map((pl: any) => new ProjectLocation(pl)) : [new ProjectLocation()];
		this.projectTitle = obj.projectTitle;
		this.receivedDeminimis = obj.receivedDeminimis;
		this.responsibleForOrganizationContact = new Contact(obj.responsibleForOrganizationContact);
		this.subtype = obj.subtype;
	}
}

class IvvDescriptions {
	IVV_PROJECT_GEGEVENS_DOELGROEPEN: string;
	IVV_PROJECT_GEGEVENS_KANSEN: string;
	IVV_PROJECT_GEGEVENS_BEHOEFTENANALYSE: string;
	IVV_PROJECT_GEGEVENS_ACTIES_SAMENWERKING: string;
	IVV_PROJECT_GEGEVENS_ACTIES_VAKANTIEBELEVING: string;
	IVV_PROJECT_GEGEVENS_ACTIES_VAKANTIE_OP_MAAT: string;
	IVV_PROJECT_GEGEVENS_POSITIEVE_BIJDRAGE: string;
	IVV_PROJECT_GEGEVENS_DEELNEMERS: string;

	constructor(obj: any = {}) {
		this.IVV_PROJECT_GEGEVENS_DOELGROEPEN = obj.IVV_PROJECT_GEGEVENS_DOELGROEPEN || '';
		this.IVV_PROJECT_GEGEVENS_KANSEN = obj.IVV_PROJECT_GEGEVENS_KANSEN || '';
		this.IVV_PROJECT_GEGEVENS_BEHOEFTENANALYSE = obj.IVV_PROJECT_GEGEVENS_BEHOEFTENANALYSE || '';
		this.IVV_PROJECT_GEGEVENS_ACTIES_SAMENWERKING = obj.IVV_PROJECT_GEGEVENS_ACTIES_SAMENWERKING || '';
		this.IVV_PROJECT_GEGEVENS_ACTIES_VAKANTIEBELEVING = obj.IVV_PROJECT_GEGEVENS_ACTIES_VAKANTIEBELEVING || '';
		this.IVV_PROJECT_GEGEVENS_ACTIES_VAKANTIE_OP_MAAT = obj.IVV_PROJECT_GEGEVENS_ACTIES_VAKANTIE_OP_MAAT || '';
		this.IVV_PROJECT_GEGEVENS_POSITIEVE_BIJDRAGE = obj.IVV_PROJECT_GEGEVENS_POSITIEVE_BIJDRAGE || '';
		this.IVV_PROJECT_GEGEVENS_DEELNEMERS = obj.IVV_PROJECT_GEGEVENS_DEELNEMERS || '';
	}
}
